import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Badge } from '../../component-badge';
import { forwardRef } from 'react';
/**
 *Can be used to display a discount within the `Price` component.
 */
export const PriceBadge = forwardRef((props, ref) => (_jsx(Badge, { size: "sm", variant: "benefit", ...props, ref: ref })));
PriceBadge.displayName = 'PriceBadge';
